import { createSelector } from 'reselect';
import { IAppState } from '../../../../../AppModulesWrapper';
import { selectAuctionBet } from './selectAuctionBet';

export const selectAuctionRestrictionType = createSelector(
  (state: IAppState) => selectAuctionBet(state),
  auctionBet => auctionBet?.restrictionType || null,
);
